import React from 'react';
import WordCloud from './wordCloud';


const OpenEnd = ({ followup }) => {
  return (
    <>
      <WordCloud words={ followup.keywords } forceColor="#595C5C" fontFamily="Roboto" />
      {
        !followup.total &&
        <div className="survey-followup-cloud_no-answers-message">No answers yet</div>
      }
    </>
  );
};

export default OpenEnd;
